/**
 * channel & campaign 管理
 * 通过推文，菜单等方式的参数
 */
import { local } from '../plugin/storage'

// 渠道本地存储key值
const CHANNEL_KEY = '_chanel_'
// 活动本地存储key值
const CAMPAIGN_KEY = '_campaign_'

export default {
  namespaced: true,

  state: () => ({
    // 渠道
    channel: local.get(CHANNEL_KEY) || '',
    // 活动
    campaign: local.get(CAMPAIGN_KEY) || ''
  }),

  getters: {
    channel: state => {
      return state.channel
    },
    campaign: state => {
      return state.campaign
    }
  },

  mutations: {
    setChannel (state, channel) {
      state.channel = channel
      local.set(CHANNEL_KEY, channel)
    },

    setCampaign (state, campaign) {
      state.campaign = campaign
      local.set(CAMPAIGN_KEY, campaign)
    }
  }
}
